import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IReSubscribeCreditCardParams, IReSubscribeCreditCardResponse } from '../../../entity';

export interface IResubscribeCreditCardUseCase {
    execute(
        payload: IReSubscribeCreditCardParams,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<IReSubscribeCreditCardResponse>;
}

export class ResubscribeCreditCardUseCase implements IResubscribeCreditCardUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IReSubscribeCreditCardParams,
        authToken: string,
        authSign: string,
        csrfToken: { [key: string]: string }
    ): Promise<IReSubscribeCreditCardResponse> {
        return await this.userRepo.resubscribeCreditCard(payload, authToken, authSign, csrfToken);
    }
}
